import React from "react";
import Status from "../Status";
import IcoMoon from "../IcoMoon";
import { ICONS, PATHS } from "../../common/constants";
import EmptyImage from "./EmptyImage";
import moment from "moment";
import { useHistory } from "react-router-dom";
import TileHeader from "./TileHeader";
import "./HomeOwnerDashboard.scss";
import { useBranding } from "../../branding/BrandingContextProvider";

const ServiceRequestList = ({
  data,
  currentUserSuite,
  onSetServiceRequestFormIsVisible,
}) => {
  const history = useHistory();

  // function to navigate service request view.
  const navigateTo = () => {
    const url = {
      pathname: PATHS.SUITES_VIEW.replace(
        ":id",
        currentUserSuite.propertyId + "&" + currentUserSuite.id
      ),
      state: {
        suite: { id: currentUserSuite.id },
        property: { id: currentUserSuite.propertyId },
        activeTab: 1,
      },
    };
    history.push(url);
  };
  const { branding } = useBranding();

  return (
    <div className="homeDasboard__mainTile">
      <div style={{ padding: 20 }}>
        <TileHeader
          heading={branding.text.serviceRequest.toUpperCase() + "S"}
          data={data}
          onNavigate={navigateTo}
          onSetServiceRequestFormIsVisible={onSetServiceRequestFormIsVisible}
        />
        {data && data.length > 0 ? (
          <div className="homeDasboard__tile">
            <div style={{ display: "flex" }}>
              <div style={{ width: "50%" }}>
                <label className="homeDasboard__tableItem">Submitted</label>
              </div>
              <div style={{ width: "50%" }}>
                <label className="homeDasboard__tableItem">Issue</label>
              </div>
            </div>
            <div className="homeDasboard__list">
              {data.map((item, i) => {
                return (
                  <div
                    className="homeDasboard__table"
                    key={i}
                    onClick={() =>
                      history.push(
                        PATHS.SERVICE_REQUESTS_VIEW.replace(":id", item.id)
                      )
                    }
                  >
                    <div style={{ display: "flex" }}>
                      <div style={{ width: "50%" }}>
                        <label className="homeDasboard__activityText">
                          {moment(item.createdDate).format("MM/DD/YYYY")}
                        </label>
                      </div>
                      <div style={{ width: "50%" }}>
                        <div style={{ display: "flex" }}>
                          <Status
                            icon={<IcoMoon glyph={ICONS[item.status]} />}
                          />
                          <label
                            className="homeDasboard__date"
                            style={{ paddingRight: 5 }}
                          >
                            {item.subject}
                          </label>
                        </div>
                      </div>
                    </div>
                  </div>
                );
              })}
            </div>
          </div>
        ) : (
          <EmptyImage
            width={200}
            height={120}
            text={`You have no open ${branding.text.serviceRequest.toLowerCase()}s.`}
            image={"/assets/empty/service-requests.svg"}
          />
        )}
      </div>
    </div>
  );
};
export default ServiceRequestList;
